import type { IconNode } from '../types';

/**
 * @name tombstone
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEgMTBoMiIgLz4KICA8cGF0aCBkPSJNMTkgMjFWMTBhNyA3IDAgMDAtMTQgMHYxMSIgLz4KICA8cGF0aCBkPSJNMiAyMWgyMCIgLz4KICA8cGF0aCBkPSJNOSAxNGg2IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/tombstone
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Tombstone: IconNode = [
  ['path', { d: 'M11 10h2' }],
  ['path', { d: 'M19 21V10a7 7 0 00-14 0v11' }],
  ['path', { d: 'M2 21h20' }],
  ['path', { d: 'M9 14h6' }],
];

export default Tombstone;
